/**
 * MRG Link Sanitizer
 * - Removes legacy SuddenRush (SRG) links that may still exist in menus, old article HTML, or app blocks.
 * - Maps common SRG destinations to the current MRG equivalents.
 */
(function () {
  function sanitizeHref(href) {
    if (!href) return href;

    var h = String(href);

    // Only touch SRG links
    if (h.indexOf('suddenrushguarana.com') === -1 && h.toLowerCase().indexOf('suddenrush') === -1) return href;

    // Normalize
    var lower = h.toLowerCase();

    // If it's a SuddenRush domain, convert to ManaRush domain first
    h = h.replace(/https?:\/\/(www\.)?suddenrushguarana\.com/ig, 'https://manarushguarana.com');

    // Map legacy paths to current best destinations
    var map = [
      [/\/collections\/the-boxes(\/)?$/i, '/collections/island-style'],
      [/\/collections\/the-boxes\/products\/.+/i, '/collections/island-style'],
      [/\/products\/.*energy-?shot.*/i, '/collections/island-style'],
      [/\/products\/(black|brown|mixed).*guarana.*shot.*/i, '/collections/island-style'],
      [/\/collections\/.*shot.*/i, '/collections/island-style']
    ];

    try {
      // Handle absolute URLs
      var u = new URL(h, window.location.origin);
      for (var i = 0; i < map.length; i++) {
        if (map[i][0].test(u.pathname)) {
          u.pathname = map[i][1];
          u.search = '';
          u.hash = '';
          return u.toString();
        }
      }
      return u.toString();
    } catch (e) {
      // Fallback for non-standard hrefs
      for (var j = 0; j < map.length; j++) {
        if (map[j][0].test(h)) return map[j][1];
      }
      return h;
    }
  }

  function run() {
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var oldHref = a.getAttribute('href');
      var newHref = sanitizeHref(oldHref);
      if (newHref && newHref !== oldHref) {
        a.setAttribute('href', newHref);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
